// ============================================================================
//  ToastContainer — Affichage des notifications toast
// ============================================================================
import { useNotificationStore } from '@/stores/notification.store'
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react'

const ICONS = {
  success: CheckCircle,
  error:   AlertCircle,
  warning: AlertTriangle,
  info:    Info,
}

const COLORS = {
  success: { bg: '#ECFDF5', border: 'rgba(16,185,129,0.3)',  icon: '#059669', title: '#065F46' },
  error:   { bg: '#FEF2F2', border: 'rgba(239,68,68,0.3)',   icon: '#DC2626', title: '#7F1D1D' },
  warning: { bg: '#FFFBEB', border: 'rgba(245,158,11,0.3)',  icon: '#D97706', title: '#78350F' },
  info:    { bg: '#EFF6FF', border: 'rgba(59,130,246,0.3)',  icon: '#2563EB', title: '#1E3A5F' },
}

export default function ToastContainer() {
  const { notifications, removeNotification } = useNotificationStore()

  // Afficher seulement les 5 plus récentes
  const toasts = notifications.slice(0, 5)

  if (toasts.length === 0) return null

  return (
    <div style={{
      position:   'fixed',
      bottom:     24,
      right:      24,
      zIndex:     9999,
      display:    'flex',
      flexDirection: 'column',
      gap:        10,
      maxWidth:   380,
      width:      '100%',
    }}>
      {toasts.map(notif => {
        const Icon   = ICONS[notif.type]
        const colors = COLORS[notif.type]
        return (
          <div
            key={notif.id}
            style={{
              background:   colors.bg,
              border:       `1px solid ${colors.border}`,
              borderLeft:   `4px solid ${colors.icon}`,
              borderRadius: 12,
              padding:      '12px 14px',
              display:      'flex',
              alignItems:   'flex-start',
              gap:          10,
              boxShadow:    '0 4px 20px rgba(13,8,32,0.12)',
              animation:    'slideInRight 0.2s ease-out',
            }}
          >
            <Icon style={{ width:18, height:18, color:colors.icon, flexShrink:0, marginTop:1 }} />
            <div style={{ flex:1, minWidth:0 }}>
              <p style={{ fontWeight:600, fontSize:13, color:colors.title, margin:0 }}>
                {notif.title}
              </p>
              {notif.message && (
                <p style={{ fontSize:12, color:'#6B7280', margin:'2px 0 0', lineHeight:1.4 }}>
                  {notif.message}
                </p>
              )}
            </div>
            <button
              onClick={() => removeNotification(notif.id)}
              style={{ color:'#9CA3AF', flexShrink:0, lineHeight:1, background:'none', border:'none', cursor:'pointer', padding:0 }}
            >
              <X style={{ width:14, height:14 }} />
            </button>
          </div>
        )
      })}
      <style>{`
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(20px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  )
}
